import { Injectable } from '@angular/core';
import { first } from 'rxjs';
import { LgvPublicRecordModel } from '../../data-models/lgv-publicRecord.model';

@Injectable({
    providedIn: 'root'
})

export class LgvPublicRecordHelper {

    public static HaveFirstLienTransaction(pr: LgvPublicRecordModel.PublicRecord): boolean {
        return this.FirstLienTransactions(pr).length > 0;
    }

    public static FirstLienTransactions(pr: LgvPublicRecordModel.PublicRecord): LgvPublicRecordModel.PublicRecordLienResult[] {

        try {
            if (pr && pr.result && pr.result.publicRecordLienResults) {
                return pr.result.publicRecordLienResults.filter(prlr => prlr.lienPosition === 1 && prlr.loanAmount && prlr.loanAmount > 0);
            }
        }
        catch (err) {
            return [];
        }

        return [];
    }

    public static MostRecentFirstLienTransaction(pr: LgvPublicRecordModel.PublicRecord): LgvPublicRecordModel.PublicRecordLienResult {

        try {
            let firstLienTransactions = this.FirstLienTransactions(pr);

            //console.log('MostRecentFirstLienTransaction:');
            //console.log('pr:')
            //console.log(pr);
            //console.log('result:')
            //console.log(pr.result);
            //console.log('records:')
            //console.log(pr.result.publicRecordLienResults);

            //console.log('FirstLienTransactions:');
            //console.log(firstLienTransactions);

            if (firstLienTransactions && firstLienTransactions.length > 0) {
                let sortedTransactions = firstLienTransactions.sort((a, b) => LgvPublicRecordHelper.PRTransactionCompareOrder(a, b));

                //console.log('sorted:');
                //console.log(sortedTransactions);

                return sortedTransactions[0];
            }
        }
        catch (err) {
            return null;
        }

        return null;
    }

    private static PRTransactionCompareOrder(a: LgvPublicRecordModel.PublicRecordLienResult, b: LgvPublicRecordModel.PublicRecordLienResult): number {
        let dateA = new Date(a.transactionDate);
        let dateB = new Date(b.transactionDate);
        return dateA > dateB ? -1 : 1;
    }


    //public static OLD_DT_HaveFirstLienTransaction(result: any): boolean {

    //    let searchResults: LgvDatatraceModel.SearchResult[] = result as LgvDatatraceModel.SearchResult[];
    //    //console.log(searchResults);

    //    if (searchResults && searchResults.length > 0) {
    //        let openLienIndex = searchResults.findIndex(sr => sr.reportName === 'OpenLienReport');
    //        if (openLienIndex > -1) {
    //            let lienReport = searchResults[openLienIndex].data as LgvDatatraceModel.ReportData;
    //            let allLienTransactions = lienReport.transactions;
    //            let firstLienTransactions = allLienTransactions.filter(x => x.lienPosition === 1);
    //            if (firstLienTransactions.length > 0) {
    //                return true;
    //            }
    //        }
    //    }


    //    return false;
    //}


    //public static OLD_DT_FirstLienTransactions(result: any): LgvDatatraceModel.Transaction[] {

    //    try {
    //        let searchResults: LgvDatatraceModel.SearchResult[] = result as LgvDatatraceModel.SearchResult[];

    //        if (searchResults && searchResults.length > 0) {
    //            let openLienIndex = searchResults.findIndex(sr => sr.reportName === 'OpenLienReport');

    //            if (openLienIndex > -1) {
    //                let lienReport = searchResults[openLienIndex].data as LgvDatatraceModel.ReportData;
    //                let allLienTransactions = lienReport.transactions;
    //                return allLienTransactions.filter(x => x.lienPosition === 1);
    //            }
    //        }
    //    }
    //    catch (err) {
    //        return [];
    //    }

    //    return [];
    //}

    //public static OLD_DT_MostRecentFirstLienTransaction(result: any): LgvDatatraceModel.Transaction {

    //    try {
    //        let firstLienTransactions = this.FirstLienTransactions(result);

    //        if (firstLienTransactions && firstLienTransactions.length > 0) {
    //            let sortedTransactions = firstLienTransactions.sort((a, b) => LgvPublicRecordHelper.DTTransactionCompareOrder(a, b));
    //            return sortedTransactions[0];
    //        }
    //    }
    //    catch (err) {
    //        return null;
    //    }

    //    return null;
    //}


    //private static OLD_DT_DTTransactionCompareOrder(a: LgvDatatraceModel.Transaction, b: LgvDatatraceModel.Transaction): number {
    //    let dateA = new Date(a.txDate);
    //    let dateB = new Date(b.txDate);
    //    return dateA > dateB ? -1 : 1;
    //}

}
